import { formatTimestamp } from "@/utils/datetime";

const originalNote = (item) => item.original_note || item.notes || item.title || "";

const CommunicationWorkspaceRow = ({
  canManageCommunications,
  item,
  onComplete,
  onConvertToTask,
  onOpenDesktop,
  onOpenMobile,
  projectLabel,
  visibilityLabel,
}) => {
  const isHistory = item.status === "complete" || Boolean(item.deleted_at);
  const isNote = item.item_type === "note";

  const handleOpen = () => {
    const isDesktop =
      typeof window !== "undefined" &&
      window.matchMedia("(min-width: 761px)").matches;
    if (isDesktop) {
      onOpenDesktop(item.id);
    } else {
      onOpenMobile(item.id);
    }
  };

  return (
    <article
      className={`communication-row ${isHistory ? "communication-item-resolved" : ""}`}
      data-testid={`communication-item-${item.id}`}
    >
      <span className="communication-row-project">
        {projectLabel(item.project_id) === "No project link"
          ? "—"
          : projectLabel(item.project_id)}
      </span>
      <div>
        <p className="communication-row-note">{originalNote(item)}</p>
        {item.additional_notes && (
          <small data-testid={`communication-additional-notes-${item.id}`}>
            Additional Notes · {item.additional_notes}
          </small>
        )}
        {(item.additional_note_entries || []).length > 0 && (
          <small data-testid={`communication-additional-note-count-${item.id}`}>
            {(item.additional_note_entries || []).length} Additional Note
            {(item.additional_note_entries || []).length === 1 ? "" : "s"}
          </small>
        )}
      </div>
      <small>{visibilityLabel(item)}</small>
      <small>
        {item.created_by_name_snapshot || "Unknown"} · {formatTimestamp(item.created_at)}
      </small>
      <div className="communication-row-actions">
        <button
          className="communication-mobile-open"
          data-testid={`mobile-communication-open-${item.id}`}
          onClick={handleOpen}
          type="button"
        >
          Open
        </button>
        <div className="communication-desktop-actions">
          {canManageCommunications && !isHistory && isNote && (
            <button
              data-testid={`communication-convert-task-${item.id}`}
              onClick={() => onConvertToTask(item.id)}
              type="button"
            >
              Make Task
            </button>
          )}
          {canManageCommunications && !isHistory && (
            <button
              data-testid={`communication-complete-${item.id}`}
              onClick={() => onComplete(item.id)}
              type="button"
            >
              Complete
            </button>
          )}
        </div>
      </div>
    </article>
  );
};

const CommunicationSection = ({
  label,
  rows,
  testId,
  sharedProps,
}) => (
  <section className="communication-row-section" data-testid={testId}>
    <h2>{label}</h2>
    <div className="communication-row-header">
      <span>Project</span>
      <span>Communication</span>
      <span>Visibility</span>
      <span>By / Time</span>
      <span>Actions</span>
    </div>
    {rows.length ? (
      rows.map((item) => (
        <CommunicationWorkspaceRow item={item} key={item.id} {...sharedProps} />
      ))
    ) : (
      <p className="communication-section-empty">No {label.toLowerCase()} in this view.</p>
    )}
  </section>
);

export const CommunicationWorkspaceRows = ({
  canManageCommunications,
  completedHistory,
  onComplete,
  onConvertToTask,
  onOpenDesktop,
  onOpenMobile,
  openItems,
  projectLabel,
  showCompletedHistory,
  taskItems,
  visibilityLabel,
}) => {
  const sharedProps = {
    canManageCommunications,
    onComplete,
    onConvertToTask,
    onOpenDesktop,
    onOpenMobile,
    projectLabel,
    visibilityLabel,
  };

  return (
    <>
      <CommunicationSection
        label="Open"
        rows={openItems}
        sharedProps={sharedProps}
        testId="communication-open-section"
      />
      <CommunicationSection
        label="Tasks"
        rows={taskItems}
        sharedProps={sharedProps}
        testId="communication-tasks-section"
      />
      {showCompletedHistory && (
        <CommunicationSection
          label="Completed History"
          rows={completedHistory}
          sharedProps={sharedProps}
          testId="communication-completed-history-section"
        />
      )}
    </>
  );
};